<template>
  <div id="paso3">
    <paso-actual />

    <div class="row mt-4">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <strong>Apellido: </strong>
        <span class="text-uppercase">{{ postulante.apellido }}</span>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <strong>Nombres: </strong>
        <span class="text-uppercase">{{ postulante.nombre }}</span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <strong>Documento: </strong>
        <span>{{ postulante.documento }}</span>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <strong>Fecha de nacimiento: </strong>
        <span>{{ postulante.fechaNacimiento | moment('DD/MM/YYYY') }}</span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-xs-12 col-ms-12 col-md-12 col-lg-12">
        <strong>Provincia: </strong>
        <span class="text-uppercase">{{ postulante.provincia.nombre }}</span>
      </div>
      <div class="col-xs-12 col-ms-12 col-md-12 col-lg-12">
        <strong>Localidad: </strong>
        <span class="text-uppercase" v-if="postulante.localidad">{{ postulante.localidad.nombre }}</span>
        <span>{{ postulante.otra_localidad }}</span>
      </div>
      <div class="col-xs-12 col-ms-12 col-md-12 col-lg-12">
        <span v-if="!postulante.localidad">-</span>
        <strong>Domicilio: </strong>
        <span class="text-uppercase">{{ postulante.domicilio }}</span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <strong>Tel&#233;fono: </strong>
        <span class="text-uppercase">{{ postulante.telefono }}</span>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <strong>Email: </strong>
        <span class="text-uppercase">{{ postulante.email }}</span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <strong>C&#243;nyugue: </strong>
        <span class="text-uppercase" v-if="postulante.conyugue">{{ postulante.conyugue }}</span>
        <span class="text-uppercase" v-if="!postulante.conyugue">-</span>
      </div>
    </div>

    <hr />

    <div class="row mt-2">
      <div class="col">
        <strong>Nivel de estudio alcanzado: </strong>
        <span class="text-uppercase">{{ nombreNivel }}</span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <strong>T&#237;tulo habilitante: </strong>
        <span class="text-uppercase" v-if="postulante.tituloHabilitante">{{ postulante.tituloHabilitante }}</span>
        <span class="text-uppercase" v-if="!postulante.tituloHabilitante">-</span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <strong>Conocimientos b&#225;sicos de computaci&#243;n: </strong>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <p v-html="conocimientosBasicos"></p>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <strong>Trabajos de referencia: </strong>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <p v-html="trabajoReferencia"></p>
      </div>
    </div>


    <div class="row mt-2">
      <div class="col">
        <strong>Sector al que se postula: </strong>
        <span v-if="postulante.sectorPostula.id!=9 && postulante.sectorPostula.pm==1">{{ postulante.sectorPostula.nombre }}</span>
        <span class="text-center" v-if="postulante.sectorPostula.pm==0 && postulante.sectorPostula.id==9">{{ postulante.otroSectorPostula }}</span>
      </div>
    </div>

    <hr />

    <div class="row mt-2">
      <div class="col-12 text-center">
        <input type="checkbox" id="reenviar" v-model="reenviarDatosCorreo" />
        <label for="reenviar">Reenviarme la informaci&#243;n ingresada a mi correo.</label>
        <button class="btn btn-success btn-sm" @click="confirmarEnviar">Confirmar y enviar</button>
        <button class="btn btn-primary btn-sm ml-4 atras" @click="$emit('continuar', 2)">Atr&#225;s</button>
      </div>
    </div>
  </div>
</template>

<script>
  import PasoActual from './PasoActual';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    data: function() {
      return {
        reenviarDatosCorreo: false
      }
    },
    computed: {
      ...mapGetters({
        postulante: 'postulante/getData',
        sectores: 'sectores/getData',
        niveles: 'nivel_estudio/getData'
      }),
      conocimientosBasicos: function() {
        return this.postulante.conocimientosBasicos.replace(/(?:\r\n|\r|\n)/g, '<br />');
      },
      trabajoReferencia: function() {
        return this.postulante.trabajoReferencia.replace(/(?:\r\n|\r|\n)/g, '<br />');
      },
      nombreSector: function() {
        let s = this.sectores;
        let f = s.filter(el => el.id == this.postulante.sectorPostula);
        if(f.length) {
          return f[ 0 ].nombre
        }
        return '';
      },
      nombreNivel: function() {
        let s = this.niveles;
        let f = s.filter(el => el.id == this.postulante.nivelEstudio.id);
        if(f.length) {
          return f[ 0 ].nombre
        }
        return '';
      }
    },
    watch: {
      reenviarDatosCorreo(newValue) {
        let reenviar = newValue===true ? 1 : 0;
        this.$store.commit('postulante/setReenviarme', reenviar);
      }
    },
    methods: {
      ...mapActions({
        post: 'postulante/post'
      }),
      confirmarEnviar: function() {
        this.post();
        this.$emit('continuar', 4);
      }
    },
    activated() {
      this.$store.commit('pasos/setPasoActivo', 3);
    },
    components: {
      'paso-actual': PasoActual
    }
  }
</script>

<style lang="sass" scoped>
  .atras
    padding-left: 25px
    padding-right: 25px
</style>



// WEBPACK FOOTER //
// src/components/Paso3.vue